<template>
  <div class="pg-query-tab" v-if="tabList.length > 0">
    <div class="pg-query-tab-items" ref="tabsRef">
      <span
        class="pg-query-tab-items-item"
        v-for="(item, index) in tabList"
        :class="{
          'pg-query-tab-items-item--active':
            item.value === activeTab?.value && item.property === activeTab?.property,
        }"
        :key="index"
        @click="changeTag(item)"
        >{{ item.name }}</span
      >
    </div>
    <div class="pg-query-tab-bar">
      <div class="pg-query-tab-bar-item" :style="batItemStyle"></div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch, nextTick } from 'vue'
import {
  setValueByPathToVue,
  setValueByPath,
  getValueByPath,
  compileData,
} from '../../../utils/index'

const props = defineProps({
  queryTabs: Array,
  data: Object,
  total: Object,
})
const emit = defineEmits(['change'])

const tabList = computed(() => {
  if (!props.queryTabs) return []
  return props.queryTabs.reduce((pre, cur) => {
    const curCompile = compileData(cur.parameter, { total: props.total })
    if (curCompile?.options?.length > 0) {
      const newOptions = curCompile.options.map((item) => {
        return {
          ...item,
          property: cur.property,
        }
      })
      pre.push(...newOptions)
    }
    return pre
  }, [])
})

const activeTab = computed(() => {
  return tabList.value.find((item) => item.value === props.data[item.property])
})

const tabsRef = ref(null)
const batItemStyle = ref({
  width: 0,
})
watch(activeTab, () => {
  nextTick(() => {
    const index = tabList.value.findIndex(
      (item) => item.value === activeTab.value?.value && item.property === activeTab.value?.property
    )
    let translateX = 0
    for (let i = 0; i < index; i++) {
      translateX += tabsRef.value?.children[i].clientWidth
    }
    batItemStyle.value = {
      width: `${index >= 0 ? tabsRef.value?.children[index].clientWidth : 0}px`,
      transform: `translateX(${index >= 0 ? translateX : 0}px)`,
    }
  })
})

const changeTag = (item) => {
  if (item.value === activeTab.value?.value && item.property === activeTab.value?.property) return
  for (const tab of tabList.value) {
    if (tab.property === item.property && getValueByPath(props.data, tab.property) !== undefined) {
      setValueByPath(props.data, tab.property, undefined)
    }
  }
  setValueByPathToVue(props.data, item.property, item.value)
  emit('change')
}
</script>
<style lang="scss">
.pg-query-tab {
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  .pg-query-tab-items {
    display: flex;
    .pg-query-tab-items-item {
      min-width: 120px;
      font-size: var(--font-size-2);
      color: var(--color-text-primary-2);
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .pg-query-tab-items-item--active {
      color: var(--color-primary);
    }
  }
  .pg-query-tab-bar {
    height: 3px;
    .pg-query-tab-bar-item {
      width: 120px;
      height: 2px;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      background-color: var(--color-primary);
    }
  }
}
</style>
